import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import FAIcon from "../FAIcon/FAIcon";
const BasicPager = (props) => {
    if (!props.hasPrevious && !props.hasNext) {
        return null;
    }
    const prev = (_jsx("li", { className: (props.hasPrevious ? "" : "disabled") + " page-item", children: _jsxs("button", { className: "page-link", onClick: props.onClickPrevious, children: [_jsx(FAIcon, { icon: "chevron-left" }), " Prev"] }) }));
    const next = (_jsx("li", { className: (props.hasNext ? "" : "disabled") + " page-item", children: _jsxs("button", { className: "page-link", onClick: props.onClickNext, children: ["Next ", _jsx(FAIcon, { icon: "chevron-right" })] }) }));
    return (_jsx("nav", { "aria-label": "Page navigation", children: _jsxs("ul", { className: "pagination pb-1", children: [prev, next] }) }));
};
export default BasicPager;
